<template>
  <vs-popup title="Filter la liste des demandes" :active.sync="isPromptActiveLocal">
    <vs-row>
      <vs-col vs-w="12">
        <span style="margin-left: -10px">Liste des charger</span>
        <v-select style="margin-left: -10px" v-model="form.charger" class="w-full" label="name"
                  placeholder="Sélectionner un charger"
                  :reduce="user => user.email"
                  :options="users"></v-select>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-button :disabled="isActive" color="primary" class="mt-2 mr-2" type="filled" @click="searchMethod()">Filtrer</vs-button>
      <vs-button color="primary" class="mt-2" type="border" @click="closeEl()">Annuler</vs-button>
    </vs-row>
  </vs-popup>
</template>

<script>
  import {_buildQuery} from "../../../helpers/helper";
  const search_temp = {
    page: 1,
    charger: ''
  }
  export default {
    name: "FilterMail",
    props: {
      isPromptActive: {
        type: Boolean,
        required: true
      },
      users:{
        type: Array,
        required: true
      },
      callBackFilter:{
        type: Function
      },
    },
    data: () => ({
      form:{
        page: 1,
        charger: ''
      },
    }),
    watch: {
      isPromptActive(val) {
        if (!val) return;
      }
    },
    computed: {
      isActive() {
        return !this.form.charger != '';
      },
      isPromptActiveLocal: {
        get() {
          return this.isPromptActive
        },
        set(val) {
          if (!val) {
            this.$emit('closePrompt')
          }
        }
      },
    },
    methods:{
      closeEl(){
        this.form = { ...search_temp }
        this.$emit('closePrompt')
      },
      searchMethod(){
        this.$vs.loading()
        this.$http.get('/outlook'+ _buildQuery(this.form)).then((response) => {
          this.$vs.loading.close()
          let stringSearch = _buildQuery(this.form)
          this.callBackFilter(response, stringSearch)
          this.$emit('closePrompt')
          this.form = { ...search_temp }
        }).catch((error) => {
          this.$vs.loading.close()
          console.log(error)
        })
      }
    }
  }
</script>

<style scoped>

</style>
